import { Axios } from "../Axios";

const verify = async (formattedPhone, code) => {
  const response = await Axios.post("/users/verify", {
    phone: formattedPhone,
    code,
  });
  return response.data;
};

export default verify;
